import React, { Component } from 'react';
import './detail.less';
import picNull from '../../assets/pic_null.png';
import locationProduct from '../../assets/location-product.png';
import send from '../../util/request';
import { Modal, Tooltip } from 'antd';
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			locationDetail: {},//详情
			productList: [],//商品列表
			picVisible: false//图片缩略图显示
		};
	}
	componentDidMount() {
		this.getDetail();
	}
	componentWillUnmount() {
    this.setState = () => false;
  }
	id = this.props.match.params.id

	getDetail = () => {
		send({
			url: '/ipp/base/info',
			method: 'POST',
			data: {
				id: this.id
			}
		}).then(res => {
			if (res.data && res.data.code === 0) {
				const { data } = res.data;
				this.setState({
					locationDetail: data,
					productList: data ? data.product : []
				});
			}
		});

	}
	handlePic = () => {
		this.setState({
			picVisible: true
		});
	}
	handleCancel = () => {
		this.setState({
			picVisible: false
		});
	}
	render() {
		const { locationDetail, productList = [], picVisible } = this.state;
		return (
			<div className='location-detail-wrap'>
				<div className='location-detail-top'>
					<div className='location-top-left'>
						<Tooltip title={locationDetail?.name}>	<span className='location-top-title'>{locationDetail ? locationDetail.name : '-'}</span></Tooltip>
						<div className='location-top-content'>
							<div className='location-top-p'>
								<span className='location-top-l'>占地面积</span>
								<span className='location-top-r' title={locationDetail?.area_covered}>{locationDetail ? locationDetail.area_covered : ''}</span>
							</div>
							<div className='location-top-p'>
								<span className='location-top-l'>产地</span>
								<span className='location-top-r' title={locationDetail?.place}>{locationDetail ? locationDetail.place : ''}</span>
							</div>
							<div className='location-top-p'>
								<span className='location-top-l'>详细地址</span>
								<span className='location-top-r' title={locationDetail?.address}>{locationDetail ? locationDetail.address : ''}</span>
							</div>
							<div className='location-top-p'>
								<span className='location-top-l'>联系人</span>
								<span className='location-top-r' title={locationDetail?.contact}>{locationDetail ? locationDetail.contact : ''}</span>
							</div>
							<div className='location-top-p'>
								<span className='location-top-l'>联系方式</span>
								<span className='location-top-r' title={locationDetail?.contact_us}>{locationDetail ? locationDetail.contact_us : ''}</span>
							</div>
						</div>
					</div>
					<div className='location-top-right'>
						<div className='location-right-content'>
							<Tooltip title={locationDetail?.company_name}>	<span className='location-top-title'>{locationDetail ? locationDetail.company_name : ''}</span></Tooltip>
							<div className='location-right-title'>营业执照</div>
							<div className='location-right-pic'>
								<div className='location-pic-right' onClick={() => this.handlePic()}>
									<img src={locationDetail.company_license || picNull} alt='' />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='location-detail-content'>
					<div className='location-content'>
						<div className='location-content-title'>主营产品</div>
						<div className='location-content-image'>
							{
								productList.length > 0 ? productList.map(item => {
									return (
										<div className='location-content-pic-list' key={item.id}>
											<img className="location-image-item" src={item.product_image || locationProduct} alt=""></img>
											<div className="title-wrap">
												<div className="title" >
													<Tooltip title={item.product_name}>	{item.product_name} </Tooltip>
												</div>
												<div className="standard"><span style={{ color: 'rgba(0,0,0,0.5)' }}>年产量：{item.annual_output}</span></div>
											</div>
										</div>

									);
								}) : ''
							}

						</div>
					</div>
				</div>
				<Modal open={picVisible} footer={null} onCancel={this.handleCancel}>
					<img alt="" style={{ width: '100%' }} src={locationDetail.company_license || picNull} />
				</Modal>
			</div>
		);
	}
}
